import LoadingIndicator from '@nobia/zeus-components/lib/loadingIndicator'
import styled, { useTheme } from '@nobia/zeus-components/lib/styled'
import React from 'react'

const LoaderDiv = styled.div`
  width: 100%;
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  > div > div {
    opacity: 1;
  }
`

export const Loader = () => {
  const theme = useTheme()
  return (
    <LoaderDiv>
      <LoadingIndicator color={theme.loadingIndicator.color} />
    </LoaderDiv>
  )
}
